<div class="btn-wrapper">
  <button
    *ngIf="userId && userId === producerId && authService.isConnected() && page!=='producer'" style="color: #82FFCA"
    [routerLink]="['/producer-edit']"
    [ngClass]="{'follow-producer-btn': page=='producer'}"
    class="follow-btn"
    type="button"
  >
    {{'producerFollowEditBtn.Edit' | translate:'Edit'}}
  </button>
  <!--Producer page "Edit page" button-->
  <button
    *ngIf="userId && userId === producerId && authService.isConnected() && page=='producer'"
    [routerLink]="['/producer-edit']"
    [ngClass]="{'follow-producer-btn': page=='producer'}"
    class="follow-btn"
    type="button"
  >
    {{'producerFollowEditBtn.Editpage' | translate:'Edit page'}}
  </button>
  <!--"Follow" button-->
  <button
    *ngIf="userId && userId !== producerId && (authService.isConnected() && isFollowing)"
    [disabled]="disableFollowButton"
    [ngClass]="{'follow-producer-btn': page=='producer'}"
    (click)="updateFollowProducer('unfollow')"
    class="follow-btn"
    type="button"
  >
    {{'producerFollowEditBtn.Following' | translate:'Following'}}
  </button>
  <button
    *ngIf="userId !== producerId && (!authService.isConnected() || !isFollowing)"
    [disabled]="disableFollowButton"
    [ngClass]="{'follow-producer-btn': page=='producer'}"
    (click)="updateFollowProducer('follow')"
    class="follow-btn follow" type="button"
  >
  <img src="/assets/images/svg-icons/follow_icon.svg" alt="Follow">
    {{'producerFollowEditBtn.Follow' | translate:'Follow'}}
  </button>
</div>
